module.exports = __webpack_public_path__ + "gi.8bab78ca.svg";